import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { useSidebar } from '@/components/ui/sidebar-context';
import { cn } from '@/lib/utils';

const TOGGLE_CLASS = cn(
  'absolute top-1/2 right-(--sidebar-inset) hidden -translate-y-1/2 items-center justify-center rounded-md outline-none md:flex',
  'after:absolute after:-inset-2',
  'group-data-[collapsible=icon]:pointer-events-none group-data-[collapsible=icon]:invisible group-data-[collapsible=icon]:opacity-0',
  'text-muted-foreground',
  'transition-[color,opacity,visibility] duration-200 motion-reduce:transition-none',
  'hover:text-sidebar-primary',
  'focus-visible:ring-2 focus-visible:ring-sidebar-primary/50',
);

function getToggleLabel(isPinnedOpen: boolean, isExpanded: boolean): string {
  if (isPinnedOpen) return 'Collapse sidebar';
  if (isExpanded) return 'Keep sidebar open';
  return 'Expand sidebar';
}

export function SidebarToggleButton() {
  const { open, state, toggleSidebar } = useSidebar();
  const label = getToggleLabel(open, state === 'expanded');
  const ToggleIcon = open ? PanelLeftClose : PanelLeftOpen;

  return (
    <button
      type="button"
      aria-label={label}
      aria-expanded={open}
      onClick={() => toggleSidebar()}
      className={TOGGLE_CLASS}
    >
      <ToggleIcon className="size-4.5" aria-hidden />
    </button>
  );
}
